<template>
  <div class="history_content">
    <div class="history" v-if="hasHistory()">
      <div class="history_box" v-for="year in historyData" :key="`historyYear${year.year}`">
        <div class="history_box_year" >{{ year.year }}</div>
        <div class="history_box_month" v-for="month in year.yearData">
          <div class="history_box_month_month">{{ month.month }}월</div>
          <div class="history_box_month_text" v-html="month.content"></div>
        </div>
      </div>
    </div>
    <div v-else>
      연혁 리스트가 없습니다.
    </div>
  </div>
</template>

<script>
import util from "@/mixins/util";

export default {
  name: "HistoryComponent",
  mixins: [],
  components: {},
  inject: [],
  provide() {
    return {}
  },
  props: {},
  data() {
    return {
      historyData: [],
    }
  },
  beforeRouterEnter() {
  },
  created() {
    this.getHistory();
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    getHistory() {
      let params = {
        ip: 0,
        obc: 'ch_date',
        obs: 'desc',
      }
      try {
        this.$api.$history.getHistory(params).then(res => res.Data.Result).then(res => {
          if (res.Info.type != 1) {
            return false;
          }
          let list = res.List;
          if (list.length === 0) {
            return;
          }
          util.Array.each(list, (obj, index, arr) => {
            let year = obj.ch_date.split('-')[0]
            if (this.historyData.findIndex(history => history.year === year) < 0) {
              let defaultData = {
                year: year,
                yearData: [],
              };
              this.historyData.push(defaultData);
            }
            let month = obj.ch_date.split('-')[1];
            let dataObj = {month: month, content: this.parsingBr(obj.ch_content)};
            let yearIndex = this.historyData.findIndex(history => history.year === year)
            this.historyData[yearIndex].yearData.push(dataObj);
          })
        })
      } catch (e) {
        this.errorAlert(e);
      }
    },
    parsingBr(content) {
      return util.isEmpty(content) ? '' : content.replace(/\n/g, "<br />");
    },
    hasHistory() {
      return !util.isEmpty(this.historyData);
    }
  },
  watch: {},
}
</script>

<style scoped>

</style>